import { NgClass } from '@angular/common';
import { Component, HostBinding, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ChartColorProvider } from '@app/helpers/chartColorProvider';
import { limitToTwoDecimalPlaces, localeNumberFormat } from '@app/helpers/number-formater';
import { NgbTooltip } from '@commonNodeModules/@ng-bootstrap/ng-bootstrap';
import { ChartModule, LegendLabelsContentArgs } from '@commonNodeModules/@progress/kendo-angular-charts';
import { NumberFormatPipe } from '@commonPipes/numberFormat';
import { TranslationService } from '@services/translation.service';
import { ChartPlaceholderPercentageComponent } from '../chart-placeholder-percentage/chart-placeholder-percentage.component';
import { ChartAlignment, IPercentageChartData, PercentageChartDataItem } from '../charts.models';

@Component({
    selector: 'app-pie-chart',
    templateUrl: './pie-chart.component.html',
    styleUrls: ['./pie-chart.component.scss'],
    imports: [NgbTooltip, ChartModule, NgClass, ChartPlaceholderPercentageComponent, NumberFormatPipe]
})
export class PieChartComponent implements IPercentageChartData, OnInit, OnChanges {
	ChartAlignment = ChartAlignment

	@Input() data: PercentageChartDataItem[]
	@Input() title?: string
	@Input() diameter?: string
	@Input() classes?: string
	@Input() hasSorting? = true;
	@Input() showPercentage? = false;
	@Input() alignment: ChartAlignment = ChartAlignment.Right
	@Input() isInH100Mode = false
	// Die folgende Codezeile setzt die Klasse w-100 auf das Host-Element des Pie-Charts (app-piechart). 
	// Wird diese nicht gesetzt, berechnet Firefox die Breite für den Placeholder nicht korrekt.
	// ACHTUNG! Sollte es nötig sein, classes auf dem hostelement manuell zu setzen, dann wird dieser Wert überschrieben.
	// In diesem Fall muss "w-100" zu den anderen manuell gesetzten Klassen hinzugefügt werden.
	@HostBinding() class = "w-100"
	dataSum: number
	defaultColors = this.chartColorProvider.getColors()
	public tooltip = {
		visible: true,
	}

	constructor(private chartColorProvider: ChartColorProvider, private translationService: TranslationService) {
	}

	ngOnInit(): void {
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes?.data?.previousValue !== changes?.data?.currentValue && this.data?.length) {

			// Summe berechnen, um Platzhalter darzustellen, falls die Summe 0 ist.
			this.dataSum = this.data.reduce((sum, item) => sum += item.value, 0)

			// DefaultColors zu jedem Dataitem hinzufügen. Der Modulus auf die Länge bedingt, dass das Farbschema von vorne beginnt, wenn die Farben ausgehen.
			this.data.forEach((item, idx) => {
				if (item.color === undefined) {
					item.color = this.defaultColors[idx % (this.defaultColors.length - 1)]
				}
				if (item.percentage === undefined) {
					item.percentage = 100 / this.dataSum * item.value
				}
				if (item.category === undefined) {
					item.category = this.translationService.getByKey(item.categoryKey);
				}
			})
			if (this.hasSorting) {
				this.data.sort((a, b) => b.value - a.value)
			}
		}
	}

	public itemText(item: PercentageChartDataItem) {
		if (this.showPercentage) {
			const percentage = localeNumberFormat(Math.round(item.percentage + Number.EPSILON));
			return item.percentage < 1 && item.percentage > 0 ? "< 1%" : `${percentage}%`;
		} else {
			return item.value;
		}

	}

	getLabelTooltip(percentage: number) {
		return `${Math.round((percentage + Number.EPSILON) * 100) / 100}%`
	}

	public defaultLabelContent = (args: LegendLabelsContentArgs) => `${args.dataItem.category}, ${args.dataItem.value} (${limitToTwoDecimalPlaces(args.dataItem.percentage)}%)`
}
